import GetScaleToolsData from '../../apiClient'
import { UPDATE_DATA_FROM_SERVER, updateSynced } from '../actions/syncActions'
import { setCellWiringData } from '../actions/cellWiringActions'
import { setLivestockData } from '../actions/livestockActions'

const updateDataFromServerMiddleware = store => next => action => {
    if (action.type === UPDATE_DATA_FROM_SERVER) {
        store.dispatch(updateSynced(false))

        GetScaleToolsData()
            .then(data => {
                const { cellWiringData, livestockShrinkData } = data
                store.dispatch(setCellWiringData(cellWiringData))
                store.dispatch(setLivestockData(livestockShrinkData))
            })
            .catch(error => {
                // Do not swallow this. redux-offline keeps replaying the last good payload from
                // localStorage, so a dead endpoint looks exactly like a working one to anybody
                // who loaded the site before it broke — which is how this went unnoticed for
                // months. Visitors with a clean profile just get empty lists.
                // eslint-disable-next-line no-console
                console.error('ScaleTools: could not load content from the CMS —', error)
            })
            .finally(() => {
                store.dispatch(updateSynced(true))
                // console.log('finally')
            })
    }

    return next(action)
}

export default updateDataFromServerMiddleware
